<template>
    <div class="page">
        <!-- 封面 + 标题区域 -->
        <div class="banner">
            <van-image class="banner-img" :src="detailData.routeImg" fit="cover"/>
            <div class="banner-overlay">
                <span class="route-name">{{ detailData.routeName }}</span>
                <div class="tag-box">
                    <van-tag v-for="(tag, index) in detailData.routeTag" :key="index"
                             class="tag" :type="tagType(index)" size="medium">
                        {{ tag }}
                    </van-tag>
                </div>
            </div>
        </div>

        <!-- 基本信息卡片 -->
        <div class="card">
            <div class="info-row">
                <span class="info-label">游玩天数</span>
                <span class="info-value">{{ detailData.routeDays }}天</span>
            </div>
            <div class="info-row">
                <span class="info-label">线路分类</span>
                <span class="info-value">{{ detailData.routeCategoryName || '-' }}</span>
            </div>
            <div class="info-row">
                <span class="info-label">驾驶总里程</span>
                <span class="info-value">{{ detailData.routeMileage }}KM</span>
            </div>
        </div>

        <!-- 按天行程卡片 -->
        <div class="card" v-if="routeOverview && routeOverview.length">
            <span class="card-title">行程安排</span>
            <div class="day-card" v-for="(day, dayIndex) in routeOverview" :key="dayIndex">
                <div class="day-header">
                    <span class="day-badge">D{{ dayIndex + 1 }}</span>
                    <span class="day-title">第{{ dayIndex + 1 }}天</span>
                </div>

                <!-- 当天景点列表 -->
                <div class="attraction-list">
                    <template v-for="(spot, spotIndex) in day.attractions">
                        <div class="attraction-item" :key="spotIndex">
                            <div class="item-line">
                                <div class="item-dot"></div>
                            </div>
                            <div class="item-content">
                                <span class="spot-name">{{ spot.visitTime ? spot.name : spot.districtName }}</span>
                                <span class="spot-time" v-if="spot.visitTime">
                                    <img src="@/assets/images/route_duration.png"/>
                                    <span>建议游览：{{ spot.visitTime }}小时</span>
                                </span>
                            </div>
                        </div>
                        <div class="drive-segment" :key="'drive-' + spotIndex"
                             v-if="spotIndex < day.attractions.length - 1 && spot.distance != null && spot.distance !== ''">
                            <div class="drive-info">
                                <div class="drive-row">
                                    <img src="@/assets/images/route_distance.png"/>
                                    <span>距离 {{ spot.distance }} 千米</span>
                                </div>
                                <div class="drive-row">
                                    <img src="@/assets/images/route_duration.png"/>
                                    <span>车程 {{ formatHour(spot.duration) }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <!-- 当日汇总 -->
                <div class="day-summary">
                    <span>当日驾驶距离：{{ day.mileage }}KM</span>
                    <span>用时：{{ formatHour(day.duration) }}</span>
                </div>
            </div>
        </div>

        <!-- 线路说明（富文本） -->
        <div class="card" v-if="detailData.routeContent">
            <span class="card-title">线路说明</span>
            <div class="content-box" v-html="detailData.routeContent"></div>
        </div>

        <!-- 注意事项 -->
        <div class="card" v-if="detailData.routeAttention">
            <span class="card-title">注意事项</span>
            <div class="content-box" v-html="detailData.routeAttention"></div>
        </div>

        <!-- 浮动按钮 -->
        <div class="float-action">
            <div class="float-btn" @click="onShareClick">
                <span>分享</span>
                <img src="@/assets/images/common/ic_share.png"/>
            </div>
            <div class="float-btn" v-if="detailData.routeAudio" @click="onSoundClick">
                <span>{{ speaking ? '暂停' : '播报' }}</span>
                <img :src="speaking
                    ? require('@/assets/images/common/ic_sound_open.png')
                    : require('@/assets/images/common/ic_sound_close.png')"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { akRoutePublicDetail } from '@/api/route.js';
    import { Image as VanImage, Button, Tag, Toast } from 'vant';
    import { WxShare } from '@/utils/wxShare';

    const wxShare = new WxShare();

    export default {
        name: "routeDetail",
        components: {
            [VanImage.name]: VanImage,
            [Button.name]: Button,
            [Tag.name]: Tag,
        },
        data() {
            return {
                id: '',
                detailData: {},
                speaking: false,
            };
        },
        computed: {
            routeOverview() {
                return this.detailData.routeOverview || [];
            }
        },
        created() {
            this.id = this.$route.query.id;
            this._fetchDetail();
        },
        destroyed() {
            if (this.$textSpeaker) {
                this.$textSpeaker.destroy();
            }
        },
        methods: {
            /**
             * 分钟转小时显示
             */
            formatHour(min) {
                if (!min) return '';
                const hours = (min / 60).toFixed(1);
                return hours + '小时';
            },

            /**
             * 请求线路详情（公开接口）
             */
            _fetchDetail() {
                if (!this.id) {
                    this.$toast('缺少线路ID');
                    return;
                }
                akRoutePublicDetail({ id: this.id }).then((res) => {
                    this.detailData = res;
                    this.pageShare();
                    if (res.routeAudio) {
                        this.handleSpeak(res.routeAudio);
                    }
                }).catch(() => {
                    this.$toast('获取线路详情失败');
                });
            },

            /**
             * 电话
             */
            phoneCall() {
                if (this.detailData.contactTel) {
                    window.location.href = 'tel://' + this.detailData.contactTel;
                }
            },

            /**
             * 标签类型
             */
            tagType(typeIndex) {
                const types = ['primary', 'danger', 'warning', 'success'];
                return types[typeIndex % 4];
            },

            // 语音播报
            handleSpeak(text) {
                if (!text || !this.$textSpeaker) return;
                this.$textSpeaker.createAudio(text);
                this.$textSpeaker.play();
                this.speaking = true;
            },

            handlePlay() {
                if (!this.$textSpeaker) return;
                this.$textSpeaker.play();
                this.speaking = true;
            },

            handlePause() {
                if (!this.$textSpeaker) return;
                this.$textSpeaker.pause();
                this.speaking = false;
            },

            // 分享配置
            pageShare() {
                const CURRENT_URL = location.href.split('#')[0];
                const SHARE_CONFIG = {
                    title: this.detailData.routeName,
                    desc: '行程天数：'+this.detailData.routeDays+'天，总里程：'+this.detailData.routeMileage+'公里',
                    link: CURRENT_URL,
                    imgUrl: this.detailData.routeImg || '',
                };
                wxShare.wxShare(SHARE_CONFIG);
            },

            onShareClick() {
                this.$toast('点击右上角，分享内容');
            },
            onSoundClick() {
                if (this.speaking) {
                    this.handlePause();
                } else {
                    this.handlePlay();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .page {
        width: 100%;
        min-height: 100vh;
        background: #f5f7fa;
        padding-bottom: 50px;
        box-sizing: border-box;
    }

    /* 封面区域 */
    .banner {
        position: relative;
        width: 100%;
        height: auto;
        aspect-ratio: 1 / 1;
        overflow: hidden;

        .banner-img {
            width: 100%;
            height: 100%;
        }

        .banner-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 12px;
            background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
            color: #fff;

            .route-name {
                font-size: 18px;
                font-weight: bold;
                display: block;
                margin-bottom: 8px;
            }

            .tag-box {
                display: flex;
                flex-wrap: wrap;

                .tag {
                    margin-right: 6px;
                    margin-bottom: 4px;
                }
            }
        }
    }

    /* 通用卡片 */
    .card {
        width: 100%;
        background: #fff;
        margin-bottom: 10px;
        padding: 12px;
        box-sizing: border-box;

        .card-title {
            font-size: 16px;
            color: #333;
            font-weight: bold;
            display: block;
            margin-bottom: 10px;
            padding-bottom: 8px;
            border-bottom: 1px solid #eee;
        }
    }

    /* 基本信息 */
    .info-row {
        display: flex;
        justify-content: space-between;
        padding: 8px 0;
        border-bottom: 1px dashed #f0f0f0;

        &:last-child {
            border-bottom: none;
        }

        .info-label {
            font-size: 14px;
            color: #999;
        }

        .info-value {
            font-size: 14px;
            color: #333;
            font-weight: 500;
        }
    }

    /* 每日卡片 */
    .day-card {
        margin-top: 12px;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        overflow: hidden;

        .day-header {
            display: flex;
            align-items: center;
            padding: 10px 12px;
            background: #f0f5ff;

            .day-badge {
                display: inline-block;
                background: #1989fa;
                color: #fff;
                font-size: 12px;
                font-weight: bold;
                padding: 2px 8px;
                border-radius: 10px;
                margin-right: 8px;
            }

            .day-title {
                font-size: 14px;
                color: #333;
                font-weight: bold;
            }
        }

        .attraction-list {
            padding: 0 12px;
            position: relative;

            /* 一条虚线贯穿所有点 */
            &::before {
                content: '';
                position: absolute;
                left: 16px;
                top: 15px;
                bottom: 25px;
                border-left: 2px dashed #1989fa;
                z-index: 0;
            }

            .attraction-item {
                display: flex;
                align-items: flex-start;
                padding: 10px 0;

                .item-line {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    flex-shrink: 0;
                    margin-right: 10px;

                    .item-dot {
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        background: #1989fa;
                        flex-shrink: 0;
                        position: relative;
                        z-index: 1;
                    }
                }

                .item-content {
                    flex: 1;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 6px;
                    padding-top: 2px;

                    .spot-name {
                        font-size: 14px;
                        color: #333;
                        font-weight: 500;
                    }

                    .spot-time {
                        font-size: 12px;
                        color: #999;
                        display: flex;
                        align-items: center;

                        img {
                            width: 12px;
                            height: 12px;
                            margin-right: 3px;
                        }
                    }
                }
            }

            .drive-segment {
                padding: 1px 0 1px 22px;

                .drive-info {
                    display: flex;
                    flex-direction: column;
                    font-size: 12px;
                    color: #999;

                    .drive-row {
                        display: flex;
                        align-items: center;
                        line-height: 20px;

                        img {
                            width: 12px;
                            height: 12px;
                            margin-right: 3px;
                        }
                    }
                }
            }
        }

        .day-summary {
            display: flex;
            justify-content: space-between;
            padding: 8px 12px;
            background: #fafafa;
            border-top: 1px dashed #eee;
            font-size: 12px;
            color: #999;
        }
    }

    /* 富文本内容 */
    .content-box {
        width: 100%;
        overflow: hidden;

        img {
            width: 100%;
        }
    }

    /* 浮动按钮 */
    .float-action {
        position: fixed;
        bottom: 16px;
        right: 16px;
        display: flex;
        flex-direction: column;
        z-index: 999;

        .float-btn {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: #fff;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 12px;

            span {
                font-size: 10px;
                color: #666;
            }

            img {
                width: 18px;
                height: 18px;
                margin-top: 2px;
            }
        }
    }
</style>
<style>
    .content-box img {
        width: 100%;
    }
</style>
